/* eslint-disable */
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
export const generateCoverageForExcel = (schema) => {
	const coverageForOptions = schema.coverage_for.options;
	const payFrequencyOptions = schema.pay_frequency.options;
	const is_smoker = schema.is_smoker;

	const excelData = {
		cells: [],
		rows: [],
		mergeCells: [],
		deleteRows: []
	};

	payFrequencyOptions.unshift("coverage_for");

	if (!coverageForOptions || !payFrequencyOptions) {
		throw new Error("coverage_for or pay_frequency options are missing in schema");
	}

	// console.log("coverageForOptions--------------->", payFrequencyOptions);

	//  this is startting of row in excel
	// let startRowIndex = 5
	let startRowIndex = 4;

	const row = {
		rowIndex: startRowIndex,
		values: payFrequencyOptions,
		font: { bold: true },
		alignment: { horizontal: "center" }
	};

	excelData.rows.push(row);
	let eachCellValueToBeWriten = {};

	for (
		let coverageForOptionsIndex = 0;
		coverageForOptionsIndex < coverageForOptions.length;
		coverageForOptionsIndex++
	) {
		const eachCoverageFor = coverageForOptions[coverageForOptionsIndex];
		const cell = `A${startRowIndex + coverageForOptionsIndex + 1}`;
		eachCellValueToBeWriten = {
			[`${cell}`]: eachCoverageFor
		};
		excelData.cells.push(eachCellValueToBeWriten);
	}

	if (schema.is_premium_depends_on_smoke) {
		let cell = `A${startRowIndex - 1}`;
		eachCellValueToBeWriten = {
			[`${cell}`]: "smoker",
			font: { bold: true, size: 12 },
			alignment: { horizontal: "center", vertical: "middle" },
			fill: {
				type: "pattern",
				pattern: "solid",
				fgColor: { argb: "DCEEC8" } // Light green background
			}
		};
		excelData.cells.push(eachCellValueToBeWriten);
		startRowIndex += coverageForOptions.length + 4;
		cell = `A${startRowIndex - 1}`;

		eachCellValueToBeWriten = {
			[`${cell}`]: "non_smoker",
			font: { bold: true, size: 12 },
			alignment: { horizontal: "center", vertical: "middle" },
			fill: {
				type: "pattern",
				pattern: "solid",
				fgColor: { argb: "DCEEC8" } // Light green background
			}
		};
		excelData.cells.push(eachCellValueToBeWriten);
		const row = {
			rowIndex: startRowIndex,
			values: payFrequencyOptions,
			font: { bold: true },
			alignment: { horizontal: "center" }
		};

		excelData.rows.push(row);
		eachCellValueToBeWriten = {};

		for (
			let coverageForOptionsIndex = 0;
			coverageForOptionsIndex < coverageForOptions.length;
			coverageForOptionsIndex++
		) {
			const eachCoverageFor = coverageForOptions[coverageForOptionsIndex];
			const cell = `A${startRowIndex + coverageForOptionsIndex + 1}`;
			eachCellValueToBeWriten = {
				[`${cell}`]: eachCoverageFor
			};
			excelData.cells.push(eachCellValueToBeWriten);
		}
	}

	return excelData;
};
export const generatecoverageVolumeExcel = (jsonArray, schema, isRecursiveCall = true, startRowIndex = 4) => {
	// const excelData = {
	// 	cells: [],
	// 	rows: []
	// };

	const excelData = {
		cells: [],
		rows: [],
		mergeCells: [],
		deleteRows: []
	};

	let eachCellValueToBeWriten = {};
	let coverageVolumeCount = 0;
	// let startRowIndex = 4

	let lastEditedRow;
	const coverageForOptions = schema.coverage_for.options;

	for (let index = 0; index < jsonArray.length; index++) {
		const eachJson = jsonArray[index];

		let haveToWriteInColumn = Number.isInteger(coverageVolumeCount / 2) ? "A" : "G";

		if (coverageVolumeCount > 1 && Number.isInteger(coverageVolumeCount / 2)) {
			startRowIndex += coverageForOptions.length + 3;
		}
		// console.log("haveToWriteInColumn----->", `${haveToWriteInColumn}${startRowIndex}`, startRowIndex);
		const coverageVolumeKey = Object.keys(eachJson)[0];
		if (coverageVolumeKey === "coverage_volume") {
			coverageVolumeCount += 1;
			//  worksheet.getCell(`${haveToWriteInColumn}${startRowIndex}`).value = eachJson["coverage_volume"];

			eachCellValueToBeWriten = {
				[`${haveToWriteInColumn}${startRowIndex}`]: eachJson["coverage_volume"],
				fill: {
					type: "pattern",
					pattern: "solid",
					fgColor: { argb: "FFCCDBF5" } // Dark Blue, Lighter 80%
				},
				alignment: { horizontal: "center", vertical: "middle" },
				font: { bold: true, size: 12 }
			};
			excelData.cells.push(eachCellValueToBeWriten);

			const columnToWriteCoverageFor = haveToWriteInColumn === "A" ? "B" : "H";

			const columnsToWritePremiumFrequencies =
				columnToWriteCoverageFor === "B" ? ["C", "D", "E"] : ["I", "J", "K"];
			for (
				let coverageForOptionsIndex = 0;
				coverageForOptionsIndex < coverageForOptions.length;
				coverageForOptionsIndex++
			) {
				const eachCoverageForOption = coverageForOptions[coverageForOptionsIndex];

				if (coverageForOptionsIndex == 0) {
					eachCellValueToBeWriten = {
						[`${columnToWriteCoverageFor}${startRowIndex + coverageForOptionsIndex}`]: "coverage_for",
						fill: {
							type: "pattern",
							pattern: "solid",
							fgColor: { argb: "FFCCDBF5" } // Dark Blue, Lighter 80%
						},
						alignment: { horizontal: "center", vertical: "middle" },
						font: { bold: true, size: 12 }
					};
					excelData.cells.push(eachCellValueToBeWriten);
					// console.log("columnsToWritePremiumFrequencies---------------->", columnsToWritePremiumFrequencies);
					for (
						let premiumFrequenciesIndex = 0;
						premiumFrequenciesIndex < columnsToWritePremiumFrequencies.length;
						premiumFrequenciesIndex++
					) {
						const eachColumnsToWritePremiumFrequencies =
							columnsToWritePremiumFrequencies[premiumFrequenciesIndex];
						const eachPremiumFrequency = schema.pay_frequency.options[premiumFrequenciesIndex];

						// console.log("eachPremiumFrequency--------->",eachPremiumFrequency);
						if (!eachPremiumFrequency) {
							break;
						}

						eachCellValueToBeWriten = {
							[`${eachColumnsToWritePremiumFrequencies}${startRowIndex + coverageForOptionsIndex}`]:
								eachPremiumFrequency,
							fill: {
								type: "pattern",
								pattern: "solid",
								fgColor: { argb: "FFCCDBF5" }
							},
							alignment: { horizontal: "center", vertical: "middle" },
							font: { bold: true, size: 12 }
						};

						excelData.cells.push(eachCellValueToBeWriten);
					}
				}

				eachCellValueToBeWriten = {
					[`${columnToWriteCoverageFor}${startRowIndex + (coverageForOptionsIndex + 1)}`]:
						eachCoverageForOption
				};
				excelData.cells.push(eachCellValueToBeWriten);

				lastEditedRow = startRowIndex + (coverageForOptionsIndex + 1);
			}
		}
	}

	// console.log("excelData------>", lastEditedRow);

	// Recursive call for smoker/non-smoker

	// Call recursion only once
	if (schema.is_premium_depends_on_smoke && isRecursiveCall) {
		let cell = `A3`;
		eachCellValueToBeWriten = {
			[`${cell}`]: "smoker",
			font: { bold: true, size: 15 },
			alignment: { horizontal: "center", vertical: "middle" },
			fill: {
				type: "pattern",
				pattern: "solid",
				fgColor: { argb: "DCEEC8" }
			}
		};
		excelData.cells.push(eachCellValueToBeWriten);
		startRowIndex = lastEditedRow + 5;

		cell = `A${startRowIndex - 1}`;

		eachCellValueToBeWriten = {
			[`${cell}`]: "non_smoker",
			font: { bold: true, size: 15 },
			alignment: { horizontal: "center", vertical: "middle" },
			fill: {
				type: "pattern",
				pattern: "solid",
				fgColor: { argb: "DCEEC8" }
			}
		};
		excelData.cells.push(eachCellValueToBeWriten);
		const extraData = generatecoverageVolumeExcel(
			jsonArray,
			{ ...schema, is_premium_depends_on_smoke: false },
			false, // Stop recursion for next call
			startRowIndex
		);
		excelData.cells.push(...extraData.cells);
	}

	return excelData;
};
export const generateBenefitAmountExcel = (schema, startRowIndex = 5, isRecursiveCall = true) => {
	// let startCoverageVolumeIndex = 3
	// let startRowIndex = 4

	const excelData = {
		cells: [],
		rows: [],
		mergeCells: [],
		deleteRows: []
	};

	let eachCellValueToBeWriten = {};
	let lastEditedRow;

	const coverageForOptions = schema.coverage_for.options;

	const benefitAmounts = schema.benefit_amount.options;

	let coverageVolumeOptions = [];

	if (schema.coverage_volume.is_present) {
		coverageVolumeOptions = schema.coverage_volume.options;
	} else {
		coverageVolumeOptions.push("");
	}

	for (
		let coverageVolumeOptionsIndex = 0;
		coverageVolumeOptionsIndex < coverageVolumeOptions.length;
		coverageVolumeOptionsIndex++
	) {
		const eachCovergeVolume = coverageVolumeOptions[coverageVolumeOptionsIndex];

		// console.log("coverageVolumeIndex--------->", eachCovergeVolume);

		for (
			let coverageForOptionsIndex = 0;
			coverageForOptionsIndex < coverageForOptions.length;
			coverageForOptionsIndex++
		) {
			const eachCoverageFor = coverageForOptions[coverageForOptionsIndex];

			// Alternate columns: even → A, odd → G
			const column = coverageForOptionsIndex % 2 === 0 ? "A" : "G";

			const row = startRowIndex + Math.floor(coverageForOptionsIndex / 2) * (benefitAmounts.length + 4);

			if (column === "A" && coverageVolumeOptions.length > 0 && coverageForOptionsIndex === 0) {
				excelData.mergeCells.push(`${column}${row - 1}:J${row - 1}`);

				eachCellValueToBeWriten = {
					[`${column}${row - 1}`]: eachCovergeVolume,
					font: { bold: true },
					alignment: { horizontal: "center", vertical: "middle" },
					fill: {
						type: "pattern",
						pattern: "solid",
						fgColor: { argb: "FF99CC00" } // Light green background
					}
				};
				excelData.cells.push(eachCellValueToBeWriten);
			}

			// console.log("row--------------", benefitAmounts.length + 1);
			const cell = `${column}${row}`;

			// console.log(
			// 	`Index: ${coverageForOptionsIndex}, Coverage: ${eachCoverageFor}, Cell: ${cell}`,
			// 	Math.floor(coverageForOptionsIndex / 2),
			// 	coverageForOptionsIndex / 2
			// );

			eachCellValueToBeWriten = {
				[`${cell}`]: eachCoverageFor,
				font: { bold: true },
				alignment: { horizontal: "center", vertical: "middle" },
				fill: {
					type: "pattern",
					pattern: "solid",
					fgColor: { argb: "C6EFCE" } // Light green background
				}
			};

			excelData.cells.push(eachCellValueToBeWriten);

			const columnsToWritePremiumFrequencies = column === "A" ? ["B", "C", "D"] : ["H", "I", "J"];

			for (
				let premiumFrequenciesIndex = 0;
				premiumFrequenciesIndex < columnsToWritePremiumFrequencies.length;
				premiumFrequenciesIndex++
			) {
				const eachColumnsToWritePremiumFrequencies = columnsToWritePremiumFrequencies[premiumFrequenciesIndex];
				const eachPremiumFrequency = schema.pay_frequency.options[premiumFrequenciesIndex];

				// console.log("eachPremiumFrequency--------->",eachPremiumFrequency);
				if (!eachPremiumFrequency) {
					break;
				}

				eachCellValueToBeWriten = {
					[`${eachColumnsToWritePremiumFrequencies}${row + 1}`]: eachPremiumFrequency,
					fill: {
						type: "pattern",
						pattern: "solid",
						fgColor: { argb: "BDD7EE" } // Dark Blue, Lighter 80%
					},
					alignment: { horizontal: "center", vertical: "middle" },
					font: { bold: true }
				};

				excelData.cells.push(eachCellValueToBeWriten);
			}

			for (let benefitAmountsIndex = 0; benefitAmountsIndex < benefitAmounts.length; benefitAmountsIndex++) {
				if (benefitAmountsIndex === 0) {
					const cell = `${column}${row + 1 + benefitAmountsIndex}`;

					eachCellValueToBeWriten = {
						[`${cell}`]: "benefit Amount",
						fill: {
							type: "pattern",
							pattern: "solid",
							fgColor: { argb: "BDD7EE" } // Dark Blue, Lighter 80%
						},
						alignment: { horizontal: "center", vertical: "middle" },
						font: { bold: true }
					};
					excelData.cells.push(eachCellValueToBeWriten);
				}
				const cell = `${column}${row + 2 + benefitAmountsIndex}`;

				// console.log("cell--->", cell);

				const eachbenefitAmount = benefitAmounts[benefitAmountsIndex];
				eachCellValueToBeWriten = {
					[`${cell}`]: eachbenefitAmount,
					alignment: { horizontal: "center", vertical: "middle" },
					font: { bold: true }
				};

				excelData.cells.push(eachCellValueToBeWriten);

				if (coverageForOptionsIndex === coverageForOptions.length - 1) {
					startRowIndex = row + benefitAmounts.length + 4;
				}

				lastEditedRow = row + 2 + benefitAmountsIndex;
			}
		}
	}

	// console.log("lastEditedRow---------->", lastEditedRow);

	if (schema.is_premium_depends_on_smoke && isRecursiveCall) {
		let cell = `A4`;

		let rowDecrease = 1;
		if (schema.coverage_volume.is_present) {
			cell = `A3`;
			// rowDecrease = 2
		}
		eachCellValueToBeWriten = {
			[cell]: "smoker",
			font: { bold: true, size: 13 },
			alignment: { horizontal: "center", vertical: "middle" },
			fill: {
				type: "pattern",
				pattern: "solid",
				fgColor: { argb: "70AD47" }
			}
		};

		excelData.cells.push(eachCellValueToBeWriten);

		startRowIndex = lastEditedRow + 6;

		// console.log("startRowIndexstartRowIndexstartRowIndexstartRowIndex-->", startRowIndex - 1);
		if (!schema.coverage_volume.is_present) {
			excelData.deleteRows.push(startRowIndex - 1);
		}
		cell = `A${startRowIndex - 2}`;
		// cell = `A60`;

		eachCellValueToBeWriten = {
			[cell]: "non_smoker",
			font: { bold: true, size: 13 },
			alignment: { horizontal: "center", vertical: "middle" },
			fill: {
				type: "pattern",
				pattern: "solid",
				fgColor: { argb: "70AD47" }
			}
		};

		excelData.cells.push(eachCellValueToBeWriten);
		const extraData = generateBenefitAmountExcel(schema, startRowIndex, false);
		excelData.cells.push(...extraData.cells);
		excelData.mergeCells.push(...extraData.mergeCells);
	}

	return excelData;
};

export const generateAgeCriteriaExcel = (schema, startRowIndex = 5, isRecursiveCall = true) => {
	// let startCoverageVolumeIndex = 3
	// let startRowIndex = 4
	// console.log("this s the schema generateAgeCriteriaExcel:", schema);

	const excelData = {
		cells: [],
		rows: [],
		mergeCells: [],
		deleteRows: []
	};

	let eachCellValueToBeWriten = {};
	let lastEditedRow;

	const coverageForOptions = schema.coverage_for.options;

	// const benefitAmounts = schema.age_criteria.options

	let coverageVolumeOptions = [];

	const columnName = schema.age_criteria.use_specific_ages ? "Age" : "Age Band";

	const benefitAmounts =
		columnName === "Age" ? schema.age_criteria.specific_age_list : schema.age_criteria.age_band_ranges;

	if (schema.coverage_volume.is_present) {
		coverageVolumeOptions = schema.coverage_volume.options;
	} else {
		coverageVolumeOptions.push("");
	}

	for (
		let coverageVolumeOptionsIndex = 0;
		coverageVolumeOptionsIndex < coverageVolumeOptions.length;
		coverageVolumeOptionsIndex++
	) {
		const eachCovergeVolume = coverageVolumeOptions[coverageVolumeOptionsIndex];

		// console.log("coverageVolumeIndex--------->", eachCovergeVolume);

		for (
			let coverageForOptionsIndex = 0;
			coverageForOptionsIndex < coverageForOptions.length;
			coverageForOptionsIndex++
		) {
			const eachCoverageFor = coverageForOptions[coverageForOptionsIndex];

			// Alternate columns: even → A, odd → G
			const column = coverageForOptionsIndex % 2 === 0 ? "A" : "G";

			const row = startRowIndex + Math.floor(coverageForOptionsIndex / 2) * (benefitAmounts.length + 4);

			if (
				column === "A" &&
				coverageVolumeOptions.length > 0 &&
				coverageForOptionsIndex === 0 &&
				coverageVolumeOptions[0] !== ""
			) {
				excelData.mergeCells.push(`${column}${row - 1}:J${row - 1}`);

				eachCellValueToBeWriten = {
					[`${column}${row - 1}`]: eachCovergeVolume,
					font: { bold: true },
					alignment: { horizontal: "center", vertical: "middle" },
					fill: {
						type: "pattern",
						pattern: "solid",
						fgColor: { argb: "FF99CC00" } // Light green background
					}
				};
				excelData.cells.push(eachCellValueToBeWriten);
			}

			// console.log("row--------------", benefitAmounts.length + 1);
			const cell = `${column}${row}`;

			// console.log(
			// 	`Index: ${coverageForOptionsIndex}, Coverage: ${eachCoverageFor}, Cell: ${cell}`,
			// 	Math.floor(coverageForOptionsIndex / 2),
			// 	coverageForOptionsIndex / 2
			// );

			eachCellValueToBeWriten = {
				[`${cell}`]: eachCoverageFor,
				font: { bold: true },
				alignment: { horizontal: "center", vertical: "middle" },
				fill: {
					type: "pattern",
					pattern: "solid",
					fgColor: { argb: "C6EFCE" } // Light green background
				}
			};

			excelData.cells.push(eachCellValueToBeWriten);

			const columnsToWritePremiumFrequencies = column === "A" ? ["B", "C", "D"] : ["H", "I", "J"];

			for (
				let premiumFrequenciesIndex = 0;
				premiumFrequenciesIndex < columnsToWritePremiumFrequencies.length;
				premiumFrequenciesIndex++
			) {
				const eachColumnsToWritePremiumFrequencies = columnsToWritePremiumFrequencies[premiumFrequenciesIndex];
				const eachPremiumFrequency = schema.pay_frequency.options[premiumFrequenciesIndex];

				// console.log("eachPremiumFrequency--------->",eachPremiumFrequency);
				if (!eachPremiumFrequency) {
					break;
				}

				eachCellValueToBeWriten = {
					[`${eachColumnsToWritePremiumFrequencies}${row + 1}`]: eachPremiumFrequency,
					fill: {
						type: "pattern",
						pattern: "solid",
						fgColor: { argb: "BDD7EE" } // Dark Blue, Lighter 80%
					},
					alignment: { horizontal: "center", vertical: "middle" },
					font: { bold: true }
				};

				excelData.cells.push(eachCellValueToBeWriten);
			}

			for (let benefitAmountsIndex = 0; benefitAmountsIndex < benefitAmounts.length; benefitAmountsIndex++) {
				if (benefitAmountsIndex === 0) {
					const cell = `${column}${row + 1 + benefitAmountsIndex}`;

					eachCellValueToBeWriten = {
						[`${cell}`]: columnName,
						fill: {
							type: "pattern",
							pattern: "solid",
							fgColor: { argb: "BDD7EE" } // Dark Blue, Lighter 80%
						},
						alignment: { horizontal: "center", vertical: "middle" },
						font: { bold: true }
					};
					excelData.cells.push(eachCellValueToBeWriten);
				}
				const cell = `${column}${row + 2 + benefitAmountsIndex}`;

				// console.log("cell--->", cell);

				const eachbenefitAmount = benefitAmounts[benefitAmountsIndex];
				eachCellValueToBeWriten = {
					[`${cell}`]: eachbenefitAmount,
					alignment: { horizontal: "center", vertical: "middle" },
					font: { bold: true }
				};

				excelData.cells.push(eachCellValueToBeWriten);

				if (coverageForOptionsIndex === coverageForOptions.length - 1) {
					startRowIndex = row + benefitAmounts.length + 4;
				}

				lastEditedRow = row + 2 + benefitAmountsIndex;
			}
		}
	}

	// console.log("lastEditedRow---------->", lastEditedRow);

	if (schema.is_premium_depends_on_smoke && isRecursiveCall) {
		let cell = `A4`;

		let rowDecrease = 1;
		if (schema.coverage_volume.is_present) {
			cell = `A3`;
			// rowDecrease = 2
		}
		eachCellValueToBeWriten = {
			[cell]: "smoker",
			font: { bold: true, size: 13 },
			alignment: { horizontal: "center", vertical: "middle" },
			fill: {
				type: "pattern",
				pattern: "solid",
				fgColor: { argb: "70AD47" }
			}
		};

		excelData.cells.push(eachCellValueToBeWriten);

		startRowIndex = lastEditedRow + 6;

		// console.log("startRowIndexstartRowIndexstartRowIndexstartRowIndex-->", startRowIndex - 1);
		if (!schema.coverage_volume.is_present) {
			excelData.deleteRows.push(startRowIndex - 1);
		}
		cell = `A${startRowIndex - 2}`;
		// cell = `A60`;

		eachCellValueToBeWriten = {
			[cell]: "non_smoker",
			font: { bold: true, size: 13 },
			alignment: { horizontal: "center", vertical: "middle" },
			fill: {
				type: "pattern",
				pattern: "solid",
				fgColor: { argb: "70AD47" }
			}
		};

		excelData.cells.push(eachCellValueToBeWriten);
		const extraData = generateAgeCriteriaExcel(schema, startRowIndex, false);
		excelData.cells.push(...extraData.cells);
		excelData.mergeCells.push(...extraData.mergeCells);
	}

	return excelData;
};
// generateBenefitAmountAndAgeCriteriaExcel

export const generateBenefitAmountAndAgeCriteriaExcel = (schema, startRowIndex = 8, isRecursiveCall = true) => {
	// console.log("this s the schema generateBenefitAmountAndAgeCriteriaExcel:", schema);

	const excelData = {
		cells: [],
		rows: [],
		mergeCells: [],
		deleteRows: []
	};

	let eachCellValueToBeWriten = {};

	let lastEditedRow;

	const columnName = schema.age_criteria.use_specific_ages ? "Age" : "Age Band";
	const ageList = columnName === "Age" ? schema.age_criteria.specific_age_list : schema.age_criteria.age_band_ranges;

	const coverageForOptions = schema.coverage_for.options;

	const benefitAmountOptions = schema.benefit_amount.options;

	const premiumFrequencyOptions = schema.pay_frequency.options;

	if (isRecursiveCall) {
		const benefitAmountOptionsWithAgeColumnNameAtFirstIndex = benefitAmountOptions.unshift(columnName);
		// console.log(
		// 	"benefitAmountOptionsWithAgeColumnNameAtFirstIndex",
		// 	benefitAmountOptionsWithAgeColumnNameAtFirstIndex,
		// 	benefitAmountOptions
		// );
	}

	let coverageVolumeOptions = [];
	if (schema.coverage_volume.is_present) {
		coverageVolumeOptions = schema.coverage_volume.options;
	} else {
		coverageVolumeOptions.push("");
	}
	// console.log("coverageVolumeOptions", coverageVolumeOptions);

	for (
		let premiumFrequenciesIndex = 0;
		premiumFrequenciesIndex < premiumFrequencyOptions.length;
		premiumFrequenciesIndex++
	) {
		let cell = `A${startRowIndex - 3}`;

		if (coverageVolumeOptions[0] !== "") {
			cell = `A${startRowIndex - 4}`;
		}
		eachCellValueToBeWriten = {
			[cell]: premiumFrequencyOptions[premiumFrequenciesIndex],
			fill: {
				type: "pattern",
				pattern: "solid",
				fgColor: { argb: "FFCCDBF5" } // Dark Blue, Lighter 80%
			},
			alignment: { horizontal: "center", vertical: "middle" },
			font: { bold: true, size: 12 }
		};

		excelData.cells.push(eachCellValueToBeWriten);

		for (
			let coverageVolumeOptionsIndex = 0;
			coverageVolumeOptionsIndex < coverageVolumeOptions.length;
			coverageVolumeOptionsIndex++
		) {
			if (coverageVolumeOptions[0] !== "") {
				excelData.mergeCells.push(`$A${startRowIndex - 3}:F${startRowIndex - 3}`);

				eachCellValueToBeWriten = {
					[`A${startRowIndex - 3}`]: coverageVolumeOptions[coverageVolumeOptionsIndex],
					font: { bold: true, size: 13 },
					alignment: { horizontal: "center", vertical: "middle" },
					fill: {
						type: "pattern",
						pattern: "solid",
						fgColor: { argb: "FF99CC00" } // Light green background
					}
				};
				excelData.cells.push(eachCellValueToBeWriten);
			}

			for (
				let coverageForOptionsIndex = 0;
				coverageForOptionsIndex < coverageForOptions.length;
				coverageForOptionsIndex++
			) {
				excelData.mergeCells.push(`$A${startRowIndex - 2}:C${startRowIndex - 2}`);

				eachCellValueToBeWriten = {
					[`A${startRowIndex - 2}`]: coverageForOptions[coverageForOptionsIndex],
					font: { bold: true, size: 13 },
					//  font: { bold: true },
					alignment: { horizontal: "center", vertical: "middle" },
					fill: {
						type: "pattern",
						pattern: "solid",
						fgColor: { argb: "C6EFCE" } // Light green background
					}
				};
				excelData.cells.push(eachCellValueToBeWriten);
				for (let ageListIndex = 0; ageListIndex < ageList.length; ageListIndex++) {
					eachCellValueToBeWriten = {
						[`A${startRowIndex + ageListIndex}`]: ageList[ageListIndex],
						font: { bold: true, size: 8 },
						alignment: { horizontal: "center", vertical: "middle" }
					};

					excelData.cells.push(eachCellValueToBeWriten);
					lastEditedRow = startRowIndex + ageListIndex;

					if (ageListIndex === ageList.length - 1) {
						const row = {
							rowIndex: startRowIndex - 1,
							values: benefitAmountOptions,
							font: { bold: true },
							alignment: { horizontal: "center" }
						};

						excelData.rows.push(row);

						// if (!isRecursiveCall) {
						// 	console.log("=========================>", row);
						// }

						// worksheet.getRow(startRowIndex - 1).values = benefitAmountOptions
						// // Get the header row
						// const headerRow = worksheet.getRow(startRowIndex - 1);
						// // Make it bold
						// headerRow.font = { bold: true };
						// // Center align the text
						// headerRow.alignment = { horizontal: 'center' };

						startRowIndex += ageListIndex + 5;

						if (coverageForOptionsIndex === coverageForOptions.length - 1) {
							startRowIndex += 2;
						}
					}
				}
				// break
			}
		}
	}

	if (schema.is_premium_depends_on_smoke && isRecursiveCall) {
		let cell = `A4`;

		let rowDecrease = 1;
		if (schema.coverage_volume.is_present) {
			cell = `A3`;
			// rowDecrease = 2
		}
		eachCellValueToBeWriten = {
			[cell]: "smoker",
			font: { bold: true, size: 13 },
			alignment: { horizontal: "center", vertical: "middle" },
			fill: {
				type: "pattern",
				pattern: "solid",
				fgColor: { argb: "70AD47" }
			}
		};

		excelData.cells.push(eachCellValueToBeWriten);

		startRowIndex = lastEditedRow + 7;

		cell = `A${startRowIndex - 4}`;
		if (schema.coverage_volume.is_present) {
			cell = `A${startRowIndex - 5}`;

			// excelData.deleteRows.push(startRowIndex - 1)
		}
		// console.log("startRowIndexstartRowIndexstartRowIndexstartRowIndex-->", cell);
		// cell = `A60`;

		eachCellValueToBeWriten = {
			[cell]: "non_smoker",
			font: { bold: true, size: 13 },
			alignment: { horizontal: "center", vertical: "middle" },
			fill: {
				type: "pattern",
				pattern: "solid",
				fgColor: { argb: "70AD47" }
			}
		};

		excelData.cells.push(eachCellValueToBeWriten);
		const extraData = generateBenefitAmountAndAgeCriteriaExcel(schema, startRowIndex, false);
		excelData.cells.push(...extraData.cells);
		excelData.mergeCells.push(...extraData.mergeCells);
		excelData.rows.push(...extraData.rows);
	}
	// console.log("excelData", excelData);
	return excelData;
};
export const generatePlanExcel = (schema, startRowIndex = 8, isRecursiveCall = true) => {
	// console.log("this s the schema:", schema);
	const excelData = {
		cells: [],
		rows: [],
		mergeCells: [],
		deleteRows: []
	};

	let lastEditedRow;

	const columnName = schema.age_criteria.use_specific_ages ? "Age" : "Age Band";
	const ageList = columnName === "Age" ? schema.age_criteria.specific_age_list : schema.age_criteria.age_band_ranges;

	const coverageForOptions = schema.coverage_for.options;
	const benefitAmountOptions = [...schema.benefit_amount.options];
	const premiumFrequencyOptions = schema.pay_frequency.options;

	if (isRecursiveCall) {
		benefitAmountOptions.unshift(columnName);
	}

	let coverageVolumeOptions = schema.coverage_volume.is_present ? schema.coverage_volume.options : [""];

	for (let pfIndex = 0; pfIndex < premiumFrequencyOptions.length; pfIndex++) {
		let cell = `A${startRowIndex - (coverageVolumeOptions[0] !== "" ? 4 : 3)}`;
		excelData.cells.push({
			[cell]: premiumFrequencyOptions[pfIndex],
			fill: { type: "pattern", pattern: "solid", fgColor: { argb: "FFCCDBF5" } },
			alignment: { horizontal: "center", vertical: "middle" },
			font: { bold: true, size: 12 }
		});

		for (let cvIndex = 0; cvIndex < coverageVolumeOptions.length; cvIndex++) {
			if (coverageVolumeOptions[0] !== "") {
				excelData.mergeCells.push(`$A${startRowIndex - 3}:F${startRowIndex - 3}`);
				excelData.cells.push({
					[`A${startRowIndex - 3}`]: coverageVolumeOptions[cvIndex],
					font: { bold: true, size: 13 },
					alignment: { horizontal: "center", vertical: "middle" },
					fill: { type: "pattern", pattern: "solid", fgColor: { argb: "FF99CC00" } }
				});
			}

			for (let cfIndex = 0; cfIndex < coverageForOptions.length; cfIndex++) {
				excelData.mergeCells.push(`$A${startRowIndex - 2}:C${startRowIndex - 2}`);
				excelData.cells.push({
					[`A${startRowIndex - 2}`]: coverageForOptions[cfIndex],
					font: { bold: true, size: 13 },
					alignment: { horizontal: "center", vertical: "middle" },
					fill: { type: "pattern", pattern: "solid", fgColor: { argb: "C6EFCE" } }
				});

				for (let ageIndex = 0; ageIndex < ageList.length; ageIndex++) {
					excelData.cells.push({
						[`A${startRowIndex + ageIndex}`]: ageList[ageIndex],
						font: { bold: true, size: 8 },
						alignment: { horizontal: "center", vertical: "middle" }
					});
					lastEditedRow = startRowIndex + ageIndex;

					if (ageIndex === ageList.length - 1) {
						excelData.rows.push({
							rowIndex: startRowIndex - 1,
							values: benefitAmountOptions,
							font: { bold: true },
							alignment: { horizontal: "center" }
						});
						startRowIndex += ageList.length + 5;
						if (cfIndex === coverageForOptions.length - 1) startRowIndex += 2;
					}
				}
			}
		}
	}

	// Premium depends on smoke
	if (schema.is_premium_depends_on_smoke && isRecursiveCall) {
		let smokerRow = `A${schema.coverage_volume.is_present ? 3 : 4}`;
		let nonSmokerRow = `A${lastEditedRow + 3}`;
		excelData.cells.push(
			{
				[smokerRow]: "smoker",
				font: { bold: true, size: 13 },
				alignment: { horizontal: "center", vertical: "middle" },
				fill: { type: "pattern", pattern: "solid", fgColor: { argb: "70AD47" } }
			},
			{
				[nonSmokerRow]: "non_smoker",
				font: { bold: true, size: 13 },
				alignment: { horizontal: "center", vertical: "middle" },
				fill: { type: "pattern", pattern: "solid", fgColor: { argb: "70AD47" } }
			}
		);

		const extraData = generatePlanExcel(schema, lastEditedRow + 7, false);
		excelData.cells.push(...extraData.cells);
		excelData.mergeCells.push(...extraData.mergeCells);
		excelData.rows.push(...extraData.rows);
	}

	// ==========================
	// --- Dependent Eligibility ---
	// ==========================
	if (schema.dependent_eligibility?.is_present) {
		let currentRow = lastEditedRow + 3;

		// Header
		excelData.cells.push({
			[`A${currentRow}`]: "Dependent Eligibility",
			font: { bold: true, size: 14 },
			alignment: { horizontal: "center", vertical: "middle" },
			fill: { type: "pattern", pattern: "solid", fgColor: { argb: "FFD9E1F2" } }
		});
		excelData.mergeCells.push(`A${currentRow}:F${currentRow}`);
		currentRow += 2;

		// Eligible / Ineligible
		(schema.dependent_eligibility.eligible_relationship || []).forEach((rel) => {
			excelData.cells.push({
				[`A${currentRow}`]: `Eligible: ${rel}`,
				font: { bold: true, size: 12 },
				alignment: { horizontal: "left", vertical: "middle" }
			});
			currentRow++;
		});
		(schema.dependent_eligibility.in_eligible_relationship || []).forEach((rel) => {
			excelData.cells.push({
				[`A${currentRow}`]: `Ineligible: ${rel}`,
				font: { bold: true, size: 12 },
				alignment: { horizontal: "left", vertical: "middle" }
			});
			currentRow++;
		});

		// Spouse / Children
		const deps = ["spouse", "children"];
		deps.forEach((dep) => {
			const data = schema.dependent_eligibility[dep];
			if (!data) return;

			excelData.cells.push({
				[`A${currentRow}`]: dep.toUpperCase(),
				font: { bold: true, size: 13 },
				alignment: { horizontal: "center", vertical: "middle" },
				fill: { type: "pattern", pattern: "solid", fgColor: { argb: "FFB7DEE8" } }
			});
			excelData.mergeCells.push(`A${currentRow}:F${currentRow}`);
			currentRow++;

			excelData.cells.push({
				[`A${currentRow}`]: "Min Age",
				[`B${currentRow}`]: data.min_age,
				[`C${currentRow}`]: "Max Age",
				[`D${currentRow}`]: data.max_age,
				font: { bold: true },
				alignment: { horizontal: "center", vertical: "middle" }
			});
			currentRow++;

			excelData.cells.push({
				[`A${currentRow}`]: "Can Exceed Employee Benefit?",
				[`B${currentRow}`]:
					data.can_spouse_has_max_benefit_amount_than_employee ||
					data.can_children_has_max_benefit_amount_than_employee ||
					false,
				font: { bold: true },
				alignment: { horizontal: "center", vertical: "middle" }
			});
			currentRow++;

			// Disabled children
			if (dep === "children" && data.disabled) {
				excelData.cells.push({
					[`A${currentRow}`]: "Disabled Children",
					font: { bold: true, size: 12 },
					fill: { type: "pattern", pattern: "solid", fgColor: { argb: "FFE6B8B7" } },
					alignment: { horizontal: "center", vertical: "middle" }
				});
				excelData.mergeCells.push(`A${currentRow}:F${currentRow}`);
				currentRow++;

				excelData.cells.push({
					[`A${currentRow}`]: "Min Age",
					[`B${currentRow}`]: data.disabled.min_age,
					[`C${currentRow}`]: "Max Age",
					[`D${currentRow}`]: data.disabled.max_age,
					font: { bold: true },
					alignment: { horizontal: "center", vertical: "middle" }
				});
				currentRow++;

				excelData.cells.push({
					[`A${currentRow}`]: "Can Exceed Employee Benefit?",
					[`B${currentRow}`]: data.disabled.children_can_exceed_employee_benefit,
					font: { bold: true },
					alignment: { horizontal: "center", vertical: "middle" }
				});
				currentRow++;
			}
		});
	}

	return excelData;
};

export const generatePremiumExcel = (schema) => {
	// console.log("key----------->0.1321321532", schema);
	const excelRows = generatePayLoadForSchemaTojson(schema);
	console.log("this is the achema whcih is comming in this", schema);

	let key = Object.keys(schema).filter((key) => schema[key]?.is_present);
	console.log("this is the key", key);

	if (key.includes("dependent_eligibility")) {
		key = key.filter((item) => item !== "dependent_eligibility");
	}
	if (key.includes("rider")) {
		key = key.filter((item) => item !== "rider");
	}

	const switchKey = key.join(" + ");

	// console.log("key----------->0.1321321532", switchKey);
	let excelData = {};
	switch (switchKey) {
		case "carrier_name + coverage_for + pay_frequency":
			excelData = generateCoverageForExcel(schema);
			break;

		case "carrier_name + coverage_for + coverage_volume + pay_frequency":
			excelData = generatecoverageVolumeExcel(excelRows, schema);
			break;

		case "carrier_name + coverage_for + pay_frequency + benefit_amount":
			excelData = generateBenefitAmountExcel(schema);
			break;

		case "carrier_name + coverage_for + coverage_volume + pay_frequency + benefit_amount":
			excelData = generateBenefitAmountExcel(schema);
			break;

		case "carrier_name + coverage_for + pay_frequency + age_criteria":
			excelData = generateAgeCriteriaExcel(schema);
			break;

		case "carrier_name + coverage_for + coverage_volume + pay_frequency + age_criteria":
			excelData = generateAgeCriteriaExcel(schema);
			break;

		case "carrier_name + coverage_for + pay_frequency + benefit_amount + age_criteria":
			// console.log("hi bro--->124567869");

			excelData = generateBenefitAmountAndAgeCriteriaExcel(schema);
			// console.log("excelData12345", excelData);

			break;
		case "carrier_name + coverage_for + coverage_volume + pay_frequency + benefit_amount + age_criteria":
			// console.log("hi bro--->124567869");
			excelData = generateBenefitAmountAndAgeCriteriaExcel(schema);
			// console.log("excelData12345", excelData);
			break;

		default:
			throw new Error("No matching case found.");
	}

	return excelData;
};

const generatePayLoadForSchemaTojson = (vebSchemaV2) => {
	try {
		// //console.log("hesdknfjksndfjknfcjksndkjfcnskdjnfcksdn111111", vebSchemaV2);
		const excelRows = [];
		let jsonObject = {};
		if (vebSchemaV2["carrier_name"]) {
			jsonObject = {
				"Carrier Name": "",
				[vebSchemaV2["carrier_name"].value]: ""
			};
			excelRows.push(jsonObject);
		}

		// Add an empty line (row) to the Excel output
		const coverageFor = vebSchemaV2["coverage_for"];

		if (coverageFor.is_present) {
			if (coverageFor.options.length === 0) throw new Error("coverage optionds must have values");
			for (let CFIndex = 0; CFIndex < coverageFor.options.length; CFIndex++) {
				const option = coverageFor.options[CFIndex];

				jsonObject = {
					coverage_for: option
				};
				excelRows.push(jsonObject);
			}
		}

		// console.log("hesdknfjksndfjknfcjksndkjfcnskdjnfcksdn3333333");

		const coverageVolume = vebSchemaV2["coverage_volume"];
		if (coverageVolume.is_present) {
			if (coverageFor.options.length === 0) throw new Error("coverage volume must have values");

			for (let CVIndex = 0; CVIndex < coverageVolume.options.length; CVIndex++) {
				const option = coverageVolume.options[CVIndex];
				// console.log("option==========>", option);
				excelRows.push({ coverage_volume: option });
			}
		}
		// console.log("hesdknfjksndfjknfcjksndkjfcnskdjnfcksdn444444");

		return excelRows;
	} catch (error) {
		console.error("Error generating Excel:", error);
	}
};

// export const jsonToExcel = async (fileName, schema) => {
// 	try {
// 		const sheets = {
// 			sheet_1: "employee_premium",
// 			standard_premium_values: [],
// 			is_rider: schema.is_this_plan_has_riders,
// 			sheet_2: "rider_premium",
// 			rider_premium_values: []
// 		};

// 		const coverageOptions = schema?.coverage_for?.options ?? [];
// 		const riderCoverageOptions = schema?.rider?.coverage_for?.options ?? [];

// 		// ── Standard plan coverage flags ──
// 		const hasEmployeeOnly = coverageOptions.includes("Employee Only");
// 		const hasEmployeeAndSpouse = coverageOptions.includes("Employee & Spouse");
// 		const hasEmployeeAndChildren = coverageOptions.includes("Employee & Children");
// 		const hasEmployeeAndFamily = coverageOptions.includes("Employee & Family");
// 		const hasSpouseOnly = coverageOptions.includes("Spouse Only");
// 		const hasChildrenOnly = coverageOptions.includes("Children Only");
// 		const hasSpouseAndChildren = coverageOptions.includes("Spouse & Children");

// 		// ── Rider coverage flags ──
// 		const riderHasSpouseOnly = riderCoverageOptions.includes("Spouse Only");
// 		const riderHasChildrenOnly = riderCoverageOptions.includes("Children Only");
// 		const riderHasSpouseAndChildren = riderCoverageOptions.includes("Spouse & Children");

// 		// ── Standard plan benefit/age flags ──
// 		const spouseBenefit =
// 			schema?.benefit_amount?.is_each_member_has_different_benefit_amount === true
// 				? schema?.benefit_amount?.spouse?.options?.length > 0
// 				: false;

// 		const spouseAgeCriteria =
// 			schema?.benefit_amount?.is_each_member_has_different_benefit_amount === true
// 				? schema?.benefit_amount?.spouse?.age_criteria?.age_band_ranges.length > 0 ||
// 				  schema?.benefit_amount?.spouse?.age_criteria?.specific_age_list.length > 0
// 				: false;

// 		const childBenefit =
// 			schema?.benefit_amount?.is_each_member_has_different_benefit_amount === true
// 				? schema?.benefit_amount?.child?.options.length > 0
// 				: false;

// 		const childAgeCriteria =
// 			schema?.benefit_amount?.is_each_member_has_different_benefit_amount === true
// 				? schema?.benefit_amount?.child?.age_criteria?.age_band_ranges.length > 0 ||
// 				  schema?.benefit_amount?.child?.age_criteria?.specific_age_list.length > 0
// 				: false;

// 		// ── Rider benefit/age flags ──
// 		const riderSpouseBenefit =
// 			schema?.rider?.benefit_amount?.is_each_member_has_different_benefit_amount === true
// 				? schema?.rider?.benefit_amount?.spouse?.options?.length > 0
// 				: false;

// 		const riderSpouseAgeCriteria =
// 			schema?.rider?.benefit_amount?.is_each_member_has_different_benefit_amount === true
// 				? schema?.rider?.benefit_amount?.spouse?.age_criteria?.age_band_ranges?.length > 0 ||
// 				  schema?.rider?.benefit_amount?.spouse?.age_criteria?.specific_age_list?.length > 0
// 				: false;

// 		const riderChildBenefit =
// 			schema?.rider?.benefit_amount?.is_each_member_has_different_benefit_amount === true
// 				? schema?.rider?.benefit_amount?.child?.options?.length > 0
// 				: false;

// 		const riderChildAgeCriteria =
// 			schema?.rider?.benefit_amount?.is_each_member_has_different_benefit_amount === true
// 				? schema?.rider?.benefit_amount?.child?.age_criteria?.age_band_ranges?.length > 0 ||
// 				  schema?.rider?.benefit_amount?.child?.age_criteria?.specific_age_list?.length > 0
// 				: false;

// 		const hasAnyEmployeeBased =
// 			hasEmployeeOnly || hasEmployeeAndSpouse || hasEmployeeAndChildren || hasEmployeeAndFamily;

// 		const hasSpouse = (hasSpouseOnly && schema?.can_each_relationship_enroll_indipendently_in_this_plan) || false;
// 		const hasChild = (hasChildrenOnly && schema?.can_each_relationship_enroll_indipendently_in_this_plan) || false;
// 		const hasSpouseAndChild = false;

// 		const riderHasSpouse =
// 			(riderHasSpouseOnly && schema?.rider?.can_each_relationship_enroll_indipendently_in_this_plan) || false;
// 		const riderHasChild =
// 			(riderHasChildrenOnly && schema?.rider?.can_each_relationship_enroll_indipendently_in_this_plan) || false;
// 		const riderHasSpouseAndChild = false;

// 		// ── Standard premium (employee-based coverages only) ──
// 		const employeeBasedOptions = ["Employee Only", "Employee & Spouse", "Employee & Children", "Employee & Family"];

// 		const standardPremiumSchema = {
// 			...schema,
// 			coverage_for: {
// 				is_present: schema.coverage_for?.is_present ?? true,
// 				options: (schema?.coverage_for?.options ?? []).filter((opt) => employeeBasedOptions.includes(opt))
// 			}
// 		};

// 		const _excelData = generatePremiumExcel(standardPremiumSchema);
// 		sheets.standard_premium_values = _excelData;

// 		// ── Rider premium (employee-based coverages only) ──
// 		if (sheets.is_rider) {
// 			const riderEmployeeBasedOptions = (schema?.rider?.coverage_for?.options ?? []).filter((opt) =>
// 				employeeBasedOptions.includes(opt)
// 			);
// 			const riderExcelData = generatePremiumExcel({
// 				carrier_name: schema.carrier_name,
// 				...schema.rider,
// 				coverage_for: {
// 					is_present: schema.rider?.coverage_for?.is_present ?? true,
// 					options: riderEmployeeBasedOptions
// 				}
// 			});
// 			sheets.rider_premium_values = riderExcelData;
// 		}

// 		// ── Standard Spouse schema ──
// 		const spouseSchema = {
// 			carrier_name: schema.carrier_name,
// 			coverage_for: { is_present: true, options: ["Spouse Only"] },
// 			coverage_volume: {
// 				is_present: schema.coverage_volume?.is_present ?? false,
// 				options: schema.coverage_volume?.options ?? []
// 			},
// 			pay_frequency: {
// 				is_present: true,
// 				options:
// 					schema.pay_frequency?.options?.filter((opt) => ["WEEKLY", "MONTHLY", "BIWEEKLY"].includes(opt)) ??
// 					[]
// 			},
// 			benefit_amount: {
// 				...schema.benefit_amount.spouse,
// 				is_present: spouseBenefit || false
// 			},
// 			age_criteria: {
// 				...schema.benefit_amount.spouse.age_criteria,
// 				is_present: spouseAgeCriteria || false
// 			},
// 			auto_approve: schema.auto_approve,
// 			is_premium_depends_on_smoke: schema.is_premium_depnends_on_spouse_smoke || false,
// 			is_this_plan_has_age_criteria: schema.age_criteria?.is_present ?? false
// 		};

// 		// ── Standard Child schema ──
// 		const childSchema = {
// 			carrier_name: schema.carrier_name,
// 			coverage_for: { is_present: true, options: ["Children Only"] },
// 			coverage_volume: {
// 				is_present: schema.coverage_volume?.is_present ?? false,
// 				options: schema.coverage_volume?.options ?? []
// 			},
// 			pay_frequency: {
// 				is_present: true,
// 				options:
// 					schema.pay_frequency?.options?.filter((opt) => ["WEEKLY", "MONTHLY", "BIWEEKLY"].includes(opt)) ??
// 					[]
// 			},
// 			benefit_amount: {
// 				...schema.benefit_amount.child,
// 				is_present: childBenefit || false
// 			},
// 			age_criteria: {
// 				...schema.benefit_amount.child?.age_criteria,
// 				is_present: childAgeCriteria || false
// 			},
// 			auto_approve: schema.auto_approve,
// 			is_premium_depends_on_smoke: schema.is_premium_depnends_on_child_smoke || false,
// 			is_this_plan_has_age_criteria: schema.age_criteria?.is_present ?? false
// 		};

// 		// ── Standard Spouse & Child schema ──
// 		const spouseAndChildSchema = {
// 			carrier_name: schema.carrier_name,
// 			coverage_for: { is_present: true, options: ["Spouse & Children"] },
// 			coverage_volume: {
// 				is_present: schema.coverage_volume?.is_present ?? false,
// 				options: schema.coverage_volume?.options ?? []
// 			},
// 			pay_frequency: {
// 				is_present: true,
// 				options:
// 					schema.pay_frequency?.options?.filter((opt) => ["WEEKLY", "MONTHLY", "BIWEEKLY"].includes(opt)) ??
// 					[]
// 			},
// 			benefit_amount: {
// 				...schema.benefit_amount.spouse_and_child,
// 				is_present: schema.benefit_amount.spouse_and_child?.options?.length > 0 ? true : false
// 			},
// 			age_criteria: {
// 				...schema.benefit_amount.spouse_and_child?.age_criteria,
// 				is_present: false
// 			},
// 			auto_approve: schema.auto_approve,
// 			is_premium_depends_on_smoke: schema.is_premium_depends_on_smoke,
// 			is_this_plan_has_age_criteria: schema.age_criteria?.is_present ?? false
// 		};

// 		// ── Rider Spouse schema ──
// 		const riderSpouseSchema = {
// 			carrier_name: schema.carrier_name,
// 			coverage_for: { is_present: true, options: ["Spouse Only"] },
// 			coverage_volume: {
// 				is_present: schema.rider?.coverage_volume?.is_present ?? false,
// 				options: schema.rider?.coverage_volume?.options ?? []
// 			},
// 			pay_frequency: {
// 				is_present: true,
// 				options:
// 					schema.rider?.pay_frequency?.options?.filter((opt) =>
// 						["WEEKLY", "MONTHLY", "BIWEEKLY"].includes(opt)
// 					) ?? []
// 			},
// 			benefit_amount: {
// 				...schema.rider?.benefit_amount?.spouse,
// 				is_present: riderSpouseBenefit || false
// 			},
// 			age_criteria: {
// 				...schema.rider?.benefit_amount?.spouse?.age_criteria,
// 				is_present: riderSpouseAgeCriteria || false
// 			},
// 			auto_approve: schema.auto_approve,
// 			is_premium_depends_on_smoke: schema.rider?.is_premium_depnends_on_spouse_smoke || false,
// 			is_this_plan_has_age_criteria: schema.rider?.age_criteria?.is_present ?? false
// 		};

// 		// ── Rider Child schema ──
// 		const riderChildSchema = {
// 			carrier_name: schema.carrier_name,
// 			coverage_for: { is_present: true, options: ["Children Only"] },
// 			coverage_volume: {
// 				is_present: schema.rider?.coverage_volume?.is_present ?? false,
// 				options: schema.rider?.coverage_volume?.options ?? []
// 			},
// 			pay_frequency: {
// 				is_present: true,
// 				options:
// 					schema.rider?.pay_frequency?.options?.filter((opt) =>
// 						["WEEKLY", "MONTHLY", "BIWEEKLY"].includes(opt)
// 					) ?? []
// 			},
// 			benefit_amount: {
// 				...schema.rider?.benefit_amount?.child,
// 				is_present: riderChildBenefit || false
// 			},
// 			age_criteria: {
// 				...schema.rider?.benefit_amount?.child?.age_criteria,
// 				is_present: riderChildAgeCriteria || false
// 			},
// 			auto_approve: schema.auto_approve,
// 			is_premium_depends_on_smoke: schema.rider?.is_premium_depnends_on_child_smoke || false,
// 			is_this_plan_has_age_criteria: schema.rider?.age_criteria?.is_present ?? false
// 		};

// 		// ── Rider Spouse & Child schema ──
// 		const riderSpouseAndChildSchema = {
// 			carrier_name: schema.carrier_name,
// 			coverage_for: { is_present: true, options: ["Spouse & Children"] },
// 			coverage_volume: {
// 				is_present: schema.rider?.coverage_volume?.is_present ?? false,
// 				options: schema.rider?.coverage_volume?.options ?? []
// 			},
// 			pay_frequency: {
// 				is_present: true,
// 				options:
// 					schema.rider?.pay_frequency?.options?.filter((opt) =>
// 						["WEEKLY", "MONTHLY", "BIWEEKLY"].includes(opt)
// 					) ?? []
// 			},
// 			benefit_amount: {
// 				...schema.rider?.benefit_amount?.spouse_and_child,
// 				is_present: schema.rider?.benefit_amount?.spouse_and_child?.options?.length > 0 ? true : false
// 			},
// 			age_criteria: {
// 				...schema.rider?.benefit_amount?.spouse_and_child?.age_criteria,
// 				is_present: false
// 			},
// 			auto_approve: schema.auto_approve,
// 			is_premium_depends_on_smoke: schema.rider?.is_premium_depends_on_smoke || false,
// 			is_this_plan_has_age_criteria: schema.rider?.age_criteria?.is_present ?? false
// 		};

// 		// ── Sheet configs ──
// 		const sheetConfigs = [
// 			// ── Standard plan sheets ──
// 			{
// 				name: "employee_premium",
// 				data: sheets.standard_premium_values
// 			},
// 			{
// 				name: "Spouse_premium",
// 				data: hasSpouse ? generatePremiumExcel(spouseSchema) : null
// 			},
// 			{
// 				name: "Child_premium",
// 				data: hasChild ? generatePremiumExcel(childSchema) : null
// 			},
// 			{
// 				name: "Spouse_Child_sheet",
// 				data: hasSpouseAndChild ? generatePremiumExcel(spouseAndChildSchema) : null
// 			},

// 			// ── Rider plan sheets ──
// 			{
// 				name: "rider_premium",
// 				data: sheets.rider_premium_values,
// 				isRider: true
// 			},
// 			{
// 				name: "rider_Spouse_premium",
// 				data: sheets.is_rider && riderHasSpouse ? generatePremiumExcel(riderSpouseSchema) : null,
// 				isRider: true
// 			},
// 			{
// 				name: "rider_Child_premium",
// 				data: sheets.is_rider && riderHasChild ? generatePremiumExcel(riderChildSchema) : null,
// 				isRider: true
// 			},
// 			{
// 				name: "rider_Spouse_Child_sheet",
// 				data:
// 					sheets.is_rider && riderHasSpouseAndChild ? generatePremiumExcel(riderSpouseAndChildSchema) : null,
// 				isRider: true
// 			}
// 		];

// 		const workbook = new ExcelJS.Workbook();

// 		for (const { name, data, isRider } of sheetConfigs) {
// 			// Skip rider sheets if plan has no riders
// 			if (isRider && !sheets.is_rider) continue;

// 			// Skip sheets with no data
// 			if (!data || !data.cells) continue;

// 			const worksheet = workbook.addWorksheet(name);

// 			worksheet.addRow(["Carrier Name", schema.carrier_name.value]);
// 			worksheet.addRow([""]);

// 			// ── Apply Cell Data ──
// 			for (let cellDataIndex = 0; cellDataIndex < data.cells.length; cellDataIndex++) {
// 				const eachCellData = data.cells[cellDataIndex];
// 				const cell = Object.keys(eachCellData).find((key) => key !== "fill");

// 				worksheet.getCell(cell).value = eachCellData[cell];

// 				if (eachCellData.fill) {
// 					worksheet.getCell(cell).fill = eachCellData.fill;
// 				}
// 				if (eachCellData.font) {
// 					worksheet.getCell(cell).font = eachCellData.font;
// 				}
// 				if (eachCellData.alignment) {
// 					worksheet.getCell(cell).alignment = eachCellData.alignment;
// 				}
// 				if (eachCellData.font && eachCellData.font.size) {
// 					worksheet.getCell(cell).font = {
// 						...worksheet.getCell(cell).font,
// 						size: eachCellData.font.size
// 					};
// 				} else {
// 					worksheet.columns.forEach((col) => {
// 						col.width = 15;
// 					});
// 				}
// 			}

// 			// ── Apply Row Data ──
// 			for (let rowIndex = 0; rowIndex < data.rows.length; rowIndex++) {
// 				const eachRow = data.rows[rowIndex];
// 				const row = worksheet.getRow(eachRow.rowIndex);
// 				row.values = eachRow.values;
// 				row.font = { bold: true, size: 12 };
// 				row.height = 20;

// 				worksheet.columns.forEach((col) => {
// 					col.width = 20;
// 				});

// 				row.font = { bold: true, size: 12 };

// 				row.eachCell({ includeEmpty: true }, (cell) => {
// 					cell.fill = {
// 						type: "pattern",
// 						pattern: "solid",
// 						fgColor: { argb: "FFCCDBF5" }
// 					};
// 					cell.alignment = { horizontal: "center", vertical: "middle" };
// 				});

// 				row.commit();
// 			}

// 			// ── Merge Cells ──
// 			for (let mergeIndex = 0; mergeIndex < data.mergeCells.length; mergeIndex++) {
// 				const mergeRef = data.mergeCells[mergeIndex];
// 				worksheet.mergeCells(mergeRef);
// 				const [startCell] = mergeRef.split(":");
// 				const cell = worksheet.getCell(startCell);
// 			}

// 			// ── Delete Rows ──
// 			for (let i = 0; i < data.deleteRows.length; i++) {
// 				const rowNum = data.deleteRows[i];
// 				worksheet.spliceRows(rowNum, 1);
// 			}

// 			// ── Final Row & Column Styling ──
// 			worksheet.getRow(1).font = { bold: true };
// 			worksheet.getRow(2).font = { bold: true };
// 			worksheet.getColumn(1).width = 22;
// 			worksheet.getColumn(2).width = 20;
// 		}

// 		// ── Trigger Download ──
// 		try {
// 			const buffer = await workbook.xlsx.writeBuffer();
// 			const blob = new Blob([buffer], {
// 				type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
// 			});
// 			saveAs(blob, fileName);
// 		} catch (err) {
// 			console.error("Error writing Excel file:", err);
// 		}
// 	} catch (error) {
// 		console.error("Error generating Excel:", error);
// 	}
// };

export const jsonToExcel = async (fileName, schema) => {
	try {
		const is_rider = schema.is_this_plan_has_riders;

		const coverageOptions = schema?.coverage_for?.options ?? [];
		const riderCoverageOptions = schema?.rider?.coverage_for?.options ?? [];

		// ── Standard plan coverage flags ──
		const hasSpouseOnly = coverageOptions.includes("Spouse Only");
		const hasChildrenOnly = coverageOptions.includes("Children Only");
		const hasSpouseAndChildren = coverageOptions.includes("Spouse & Children");

		// ── Rider coverage flags ──
		const riderHasSpouseOnly = riderCoverageOptions.includes("Spouse Only");
		const riderHasChildrenOnly = riderCoverageOptions.includes("Children Only");
		const riderHasSpouseAndChildren = riderCoverageOptions.includes("Spouse & Children");

		// ── Standard plan benefit/age flags ──
		const spouseBenefit =
			schema?.benefit_amount?.is_each_member_has_different_benefit_amount === true
				? schema?.benefit_amount?.spouse?.options?.length > 0
				: false;

		const spouseAgeCriteria =
			schema?.benefit_amount?.is_each_member_has_different_benefit_amount === true
				? schema?.benefit_amount?.spouse?.age_criteria?.age_band_ranges.length > 0 ||
				  schema?.benefit_amount?.spouse?.age_criteria?.specific_age_list.length > 0
				: false;

		const childBenefit =
			schema?.benefit_amount?.is_each_member_has_different_benefit_amount === true
				? schema?.benefit_amount?.child?.options.length > 0
				: false;

		const childAgeCriteria =
			schema?.benefit_amount?.is_each_member_has_different_benefit_amount === true
				? schema?.benefit_amount?.child?.age_criteria?.age_band_ranges.length > 0 ||
				  schema?.benefit_amount?.child?.age_criteria?.specific_age_list.length > 0
				: false;

		// ── Rider benefit/age flags ──
		const riderSpouseBenefit =
			schema?.rider?.benefit_amount?.is_each_member_has_different_benefit_amount === true
				? schema?.rider?.benefit_amount?.spouse?.options?.length > 0
				: false;

		const riderSpouseAgeCriteria =
			schema?.rider?.benefit_amount?.is_each_member_has_different_benefit_amount === true
				? schema?.rider?.benefit_amount?.spouse?.age_criteria?.age_band_ranges?.length > 0 ||
				  schema?.rider?.benefit_amount?.spouse?.age_criteria?.specific_age_list?.length > 0
				: false;

		const riderChildBenefit =
			schema?.rider?.benefit_amount?.is_each_member_has_different_benefit_amount === true
				? schema?.rider?.benefit_amount?.child?.options?.length > 0
				: false;

		const riderChildAgeCriteria =
			schema?.rider?.benefit_amount?.is_each_member_has_different_benefit_amount === true
				? schema?.rider?.benefit_amount?.child?.age_criteria?.age_band_ranges?.length > 0 ||
				  schema?.rider?.benefit_amount?.child?.age_criteria?.specific_age_list?.length > 0
				: false;

		// ── Independent enrollment flags ──
		const hasSpouse = (hasSpouseOnly && schema?.can_each_relationship_enroll_indipendently_in_this_plan) || false;
		const hasChild = (hasChildrenOnly && schema?.can_each_relationship_enroll_indipendently_in_this_plan) || false;
		const hasSpouseAndChild = false;

		const riderHasSpouse =
			(riderHasSpouseOnly && schema?.rider?.can_each_relationship_enroll_indipendently_in_this_plan) || false;
		const riderHasChild =
			(riderHasChildrenOnly && schema?.rider?.can_each_relationship_enroll_indipendently_in_this_plan) || false;
		const riderHasSpouseAndChild = false;

		const employeeBasedOptions = ["Employee Only", "Employee & Spouse", "Employee & Children", "Employee & Family"];

		// ── Standard employee premium schema ──
		const standardPremiumSchema = {
			...schema,
			coverage_for: {
				is_present: schema.coverage_for?.is_present ?? true,
				options: (schema?.coverage_for?.options ?? []).filter((opt) => employeeBasedOptions.includes(opt))
			}
		};

		// ── Rider employee premium schema ──
		const riderEmployeePremiumSchema = (() => {
			if (!is_rider) return null;

			const filteredOptions = (schema?.rider?.coverage_for?.options ?? []).filter((opt) =>
				employeeBasedOptions.includes(opt)
			);

			if (filteredOptions.length === 0) return null;

			return {
				carrier_name: schema.carrier_name,
				...schema.rider,
				coverage_for: {
					is_present: schema.rider?.coverage_for?.is_present ?? true,
					options: filteredOptions
				}
			};
		})();

		// ── Standard Spouse schema ──
		const spouseSchema = {
			carrier_name: schema.carrier_name,
			coverage_for: { is_present: true, options: ["Spouse Only"] },
			coverage_volume: {
				is_present: schema.coverage_volume?.is_present ?? false,
				options: schema.coverage_volume?.options ?? []
			},
			pay_frequency: {
				is_present: true,
				options:
					schema.pay_frequency?.options?.filter((opt) => ["WEEKLY", "MONTHLY", "BIWEEKLY"].includes(opt)) ??
					[]
			},
			benefit_amount: { ...schema.benefit_amount.spouse, is_present: spouseBenefit || false },
			age_criteria: { ...schema.benefit_amount.spouse.age_criteria, is_present: spouseAgeCriteria || false },
			auto_approve: schema.auto_approve,
			is_premium_depends_on_smoke: schema.is_premium_depnends_on_spouse_smoke || false,
			is_this_plan_has_age_criteria: schema.age_criteria?.is_present ?? false
		};

		// ── Standard Child schema ──
		const childSchema = {
			carrier_name: schema.carrier_name,
			coverage_for: { is_present: true, options: ["Children Only"] },
			coverage_volume: {
				is_present: schema.coverage_volume?.is_present ?? false,
				options: schema.coverage_volume?.options ?? []
			},
			pay_frequency: {
				is_present: true,
				options:
					schema.pay_frequency?.options?.filter((opt) => ["WEEKLY", "MONTHLY", "BIWEEKLY"].includes(opt)) ??
					[]
			},
			benefit_amount: { ...schema.benefit_amount.child, is_present: childBenefit || false },
			age_criteria: { ...schema.benefit_amount.child?.age_criteria, is_present: childAgeCriteria || false },
			auto_approve: schema.auto_approve,
			is_premium_depends_on_smoke: schema.is_premium_depnends_on_child_smoke || false,
			is_this_plan_has_age_criteria: schema.age_criteria?.is_present ?? false
		};

		// ── Standard Spouse & Child schema ──
		const spouseAndChildSchema = {
			carrier_name: schema.carrier_name,
			coverage_for: { is_present: true, options: ["Spouse & Children"] },
			coverage_volume: {
				is_present: schema.coverage_volume?.is_present ?? false,
				options: schema.coverage_volume?.options ?? []
			},
			pay_frequency: {
				is_present: true,
				options:
					schema.pay_frequency?.options?.filter((opt) => ["WEEKLY", "MONTHLY", "BIWEEKLY"].includes(opt)) ??
					[]
			},
			benefit_amount: {
				...schema.benefit_amount.spouse_and_child,
				is_present: schema.benefit_amount.spouse_and_child?.options?.length > 0
			},
			age_criteria: { ...schema.benefit_amount.spouse_and_child?.age_criteria, is_present: false },
			auto_approve: schema.auto_approve,
			is_premium_depends_on_smoke: schema.is_premium_depends_on_smoke,
			is_this_plan_has_age_criteria: schema.age_criteria?.is_present ?? false
		};

		// ── Rider Spouse schema ──
		const riderSpouseSchema = {
			carrier_name: schema.carrier_name,
			coverage_for: { is_present: true, options: ["Spouse Only"] },
			coverage_volume: {
				is_present: schema.rider?.coverage_volume?.is_present ?? false,
				options: schema.rider?.coverage_volume?.options ?? []
			},
			pay_frequency: {
				is_present: true,
				options:
					schema.rider?.pay_frequency?.options?.filter((opt) =>
						["WEEKLY", "MONTHLY", "BIWEEKLY"].includes(opt)
					) ?? []
			},
			benefit_amount: { ...schema.rider?.benefit_amount?.spouse, is_present: riderSpouseBenefit || false },
			age_criteria: {
				...schema.rider?.benefit_amount?.spouse?.age_criteria,
				is_present: riderSpouseAgeCriteria || false
			},
			auto_approve: schema.auto_approve,
			is_premium_depends_on_smoke: schema.rider?.is_premium_depnends_on_spouse_smoke || false,
			is_this_plan_has_age_criteria: schema.rider?.age_criteria?.is_present ?? false
		};

		// ── Rider Child schema ──
		const riderChildSchema = {
			carrier_name: schema.carrier_name,
			coverage_for: { is_present: true, options: ["Children Only"] },
			coverage_volume: {
				is_present: schema.rider?.coverage_volume?.is_present ?? false,
				options: schema.rider?.coverage_volume?.options ?? []
			},
			pay_frequency: {
				is_present: true,
				options:
					schema.rider?.pay_frequency?.options?.filter((opt) =>
						["WEEKLY", "MONTHLY", "BIWEEKLY"].includes(opt)
					) ?? []
			},
			benefit_amount: { ...schema.rider?.benefit_amount?.child, is_present: riderChildBenefit || false },
			age_criteria: {
				...schema.rider?.benefit_amount?.child?.age_criteria,
				is_present: riderChildAgeCriteria || false
			},
			auto_approve: schema.auto_approve,
			is_premium_depends_on_smoke: schema.rider?.is_premium_depnends_on_child_smoke || false,
			is_this_plan_has_age_criteria: schema.rider?.age_criteria?.is_present ?? false
		};

		// ── Rider Spouse & Child schema ──
		const riderSpouseAndChildSchema = {
			carrier_name: schema.carrier_name,
			coverage_for: { is_present: true, options: ["Spouse & Children"] },
			coverage_volume: {
				is_present: schema.rider?.coverage_volume?.is_present ?? false,
				options: schema.rider?.coverage_volume?.options ?? []
			},
			pay_frequency: {
				is_present: true,
				options:
					schema.rider?.pay_frequency?.options?.filter((opt) =>
						["WEEKLY", "MONTHLY", "BIWEEKLY"].includes(opt)
					) ?? []
			},
			benefit_amount: {
				...schema.rider?.benefit_amount?.spouse_and_child,
				is_present: schema.rider?.benefit_amount?.spouse_and_child?.options?.length > 0
			},
			age_criteria: { ...schema.rider?.benefit_amount?.spouse_and_child?.age_criteria, is_present: false },
			auto_approve: schema.auto_approve,
			is_premium_depends_on_smoke: schema.rider?.is_premium_depends_on_smoke || false,
			is_this_plan_has_age_criteria: schema.rider?.age_criteria?.is_present ?? false
		};

		//  this is  all the sheet config
		const sheetConfigs = [
			{
				name: "Standard Plan",
				outputKey: "standard_premium",
				isRider: false,
				children: [
					{
						name: "employee_premium",
						outputKey: "employee_premium",
						data: generatePremiumExcel(standardPremiumSchema)
					},
					{
						name: "Spouse_premium",
						outputKey: "Spouse_premium",
						data: hasSpouse ? generatePremiumExcel(spouseSchema) : null
					},
					{
						name: "Child_premium",
						outputKey: "Child_premium",
						data: hasChild ? generatePremiumExcel(childSchema) : null
					}
					// {
					// 	name: "Spouse_Child_premium",
					// 	outputKey: "Spouse_Child_premium",
					// 	data: hasSpouseAndChild ? generatePremiumExcel(spouseAndChildSchema) : null
					// }
				]
			},
			{
				name: "Rider Plan",
				outputKey: "rider_premium",
				isRider: true,
				children: [
					{
						name: "employee_premium",
						outputKey: "employee_premium",
						data:
							is_rider && riderEmployeePremiumSchema
								? generatePremiumExcel(riderEmployeePremiumSchema)
								: null
					},
					{
						name: "Spouse_premium",
						outputKey: "Spouse_premium",
						data: is_rider && riderHasSpouse ? generatePremiumExcel(riderSpouseSchema) : null
					},
					{
						name: "Child_premium",
						outputKey: "Child_premium",
						data: is_rider && riderHasChild ? generatePremiumExcel(riderChildSchema) : null
					}
					// {
					// 	name: "Spouse_Child_premium",
					// 	outputKey: "Spouse_Child_premium",
					// 	data:
					// 		is_rider && riderHasSpouseAndChild ? generatePremiumExcel(riderSpouseAndChildSchema) : null
					// }
				]
			}
		];

		// build premium json
		const payFrequencies =
			schema.pay_frequency?.options?.filter((opt) => ["WEEKLY", "MONTHLY", "BIWEEKLY"].includes(opt)) ?? [];

		const riderPayFrequencies =
			schema.rider?.pay_frequency?.options?.filter((opt) => ["WEEKLY", "MONTHLY", "BIWEEKLY"].includes(opt)) ??
			[];

		const buildCoverageJson = (coverageOptions, freqOptions) => {
			const result = {};
			coverageOptions.forEach((coverage) => {
				result[coverage] = {};
				freqOptions.forEach((freq) => {
					result[coverage][freq] = 0;
				});
			});
			return result;
		};

		const premiumAmountJson = {
			standard_premium: {
				...(standardPremiumSchema.coverage_for.options.length > 0 && {
					employee_premium: buildCoverageJson(standardPremiumSchema.coverage_for.options, payFrequencies)
				}),
				...(hasSpouse && {
					Spouse_premium: buildCoverageJson(["Spouse Only"], payFrequencies)
				}),
				...(hasChild && {
					Child_premium: buildCoverageJson(["Children Only"], payFrequencies)
				}),
				...(hasSpouseAndChild && {
					Spouse_Child_premium: buildCoverageJson(["Spouse & Children"], payFrequencies)
				})
			},
			...(is_rider && {
				rider_premium: {
					...(riderEmployeePremiumSchema && {
						employee_premium: buildCoverageJson(
							riderEmployeePremiumSchema.coverage_for.options,
							riderPayFrequencies
						)
					}),
					...(riderHasSpouse && {
						Spouse_premium: buildCoverageJson(["Spouse Only"], riderPayFrequencies)
					}),
					...(riderHasChild && {
						Child_premium: buildCoverageJson(["Children Only"], riderPayFrequencies)
					}),
					...(riderHasSpouseAndChild && {
						Spouse_Child_premium: buildCoverageJson(["Spouse & Children"], riderPayFrequencies)
					})
				}
			})
		};

		// ── Build Workbook ──
		const workbook = new ExcelJS.Workbook();

		for (const parentConfig of sheetConfigs) {
			// Skip entire rider group if plan has no riders
			if (parentConfig.isRider && !is_rider) continue;

			for (const { name, data } of parentConfig.children) {
				// Skip children with no data
				if (!data || !data.cells) continue;

				const worksheet = workbook.addWorksheet(parentConfig.isRider ? `rider_${name}` : name);

				if (parentConfig.isRider) {
					worksheet.properties.tabColor = { argb: "FF4472C4" };
				}

				worksheet.addRow(["Carrier Name", schema.carrier_name.value]);
				worksheet.addRow([""]);

				for (let i = 0; i < data.cells.length; i++) {
					const eachCellData = data.cells[i];
					const cell = Object.keys(eachCellData).find((key) => key !== "fill");

					worksheet.getCell(cell).value = eachCellData[cell];

					if (eachCellData.fill) worksheet.getCell(cell).fill = eachCellData.fill;
					if (eachCellData.font) worksheet.getCell(cell).font = eachCellData.font;
					if (eachCellData.alignment) worksheet.getCell(cell).alignment = eachCellData.alignment;

					if (eachCellData.font?.size) {
						worksheet.getCell(cell).font = {
							...worksheet.getCell(cell).font,
							size: eachCellData.font.size
						};
					} else {
						worksheet.columns.forEach((col) => {
							col.width = 15;
						});
					}
				}

				for (let i = 0; i < data.rows.length; i++) {
					const eachRow = data.rows[i];
					const row = worksheet.getRow(eachRow.rowIndex);
					row.values = eachRow.values;
					row.height = 20;

					worksheet.columns.forEach((col) => {
						col.width = 20;
					});

					row.font = { bold: true, size: 12 };
					row.eachCell({ includeEmpty: true }, (cell) => {
						cell.fill = {
							type: "pattern",
							pattern: "solid",
							fgColor: { argb: "FFCCDBF5" }
						};
						cell.alignment = { horizontal: "center", vertical: "middle" };
					});

					row.commit();
				}

				for (let i = 0; i < data.mergeCells.length; i++) {
					worksheet.mergeCells(data.mergeCells[i]);
				}

				for (let i = 0; i < data.deleteRows.length; i++) {
					worksheet.spliceRows(data.deleteRows[i], 1);
				}

				worksheet.getRow(1).font = { bold: true };
				worksheet.getRow(2).font = { bold: true };
				worksheet.getColumn(1).width = 22;
				worksheet.getColumn(2).width = 20;
			}
		}

		const buffer = await workbook.xlsx.writeBuffer();
		const blob = new Blob([buffer], {
			type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
		});
		saveAs(blob, fileName);

		return premiumAmountJson;
	} catch (error) {
		console.error("Error generating Excel:", error);
	}
};
